// Traducciones para ECMRDocumentoPage
export const ecmrTranslations = {
  es: {
    'seo-title': 'eCMR Obligatorio España 2026: Documento de Control Digital | BlueCMR',
    'seo-description': '¿Es obligatorio el eCMR en España 2026? Descubre qué documento es realmente obligatorio para transporte nacional, por qué el eCMR no lo necesita y cómo digitalizar tus CMR internacionales.',
    'seo-keywords': 'ecmr obligatorio españa 2026, documento control digital obligatorio 2026, ecmr españa, carta porte digital obligatoria, cmr electrónico obligatorio, normativa transporte 2026',
    'valid-countries': '✅ VÁLIDO EN CERCA DE 40 PAÍSES - Protocolo eCMR 2008',
    'hero-title': 'eCMR: qué es, validez legal y cómo funciona la carta de porte digital',
    'protocol': 'Protocolo eCMR 2008',
    'signature': 'Firma electrónica eIDAS',
    'efti-ready': 'Diseñado para eFTI',
    'demo-title': 'Solicitar información',
    'demo-subtitle': 'Descubre cómo digitalizar tus eCMRs',
    'full-name': 'Nombre completo *',
    'company': 'Empresa *',
    'corporate-email': 'Email corporativo *',
    'phone': 'Teléfono *',
    'accept-privacy': 'Acepto la',
    'privacy-policy': 'política de privacidad',
    'accept-treatment': 'y el tratamiento de mis datos para recibir información comercial sobre BlueCMR.',
    'sending': 'Enviando...',
    'request-demo': 'Solicitar Demo Gratuita',
    'request-trial': 'Periodo de prueba',
    'select-interest': 'Seleccione una de las opciones:',
    'what-is-title': '¿Qué es el eCMR?',
    'what-is-intro': 'El eCMR es la carta de porte CMR en formato digital. Tiene la misma validez jurídica que el documento en papel y permite:',
    'formalize-contract': 'Formalizar el contrato de transporte',
    'document-cargo': 'Documentar la carga, el transporte y la entrega',
    'register-incidents': 'Registrar incidencias u observaciones',
    'share-info': 'Compartir la información entre cargador, transportista y destinatario',
    'electronic-benefits': 'Al ser electrónico, el eCMR añade firma electrónica avanzada, sellos de tiempo, integridad documental y mayor trazabilidad frente al formato en papel.',
    'how-works-title': '¿Cómo funciona un eCMR?',
    'how-works-intro': 'El funcionamiento de un eCMR sigue el mismo flujo operativo que el CMR tradicional, pero en formato digital y con trazabilidad completa.',
    'flow-title': 'Flujo del eCMR paso a paso',
    'step1-title': '1. Creación del documento',
    'step1-desc': 'El eCMR se crea digitalmente a partir de plantillas, formularios o mediante integración con sistemas TMS o ERP.',
    'step2-title': '2. Compartición con las partes',
    'step2-desc': 'El documento se comparte con cargador, transportista, conductor y destinatario mediante enlaces seguros (email, QR o SMS).',
    'step3-title': '3. Firma electrónica',
    'step3-desc': 'Las partes firman electrónicamente el eCMR en origen y destino, con firma avanzada conforme a eIDAS.',
    'step4-title': '4. Registro de eventos durante el transporte',
    'step4-desc': 'Durante el trayecto pueden registrarse incidencias, observaciones, cambios operativos o reservas del conductor.',
    'step5-title': '5. Cierre y conservación',
    'step5-desc': 'Una vez finalizado el transporte, el eCMR queda cerrado y conservado junto con todas sus evidencias, accesible para auditorías e inspecciones.',
    'legal-validity-title': 'Validez legal del eCMR',
    'legal-validity-intro': 'El eCMR tiene plena validez jurídica y es legalmente equivalente al CMR en papel.',
    'protocol-2008': 'Regulado por el Protocolo eCMR (2008)',
    'protocol-2008-desc': 'Equivalencia legal plena entre soporte electrónico y papel.',
    'unefact-design': 'Basado en estándares UN/CEFACT',
    'unefact-design-desc': 'Diseño conforme a las guías internacionales de la ONU.',
    '38-countries': 'Utilizado en cerca de 40 países',
    '38-countries-desc': 'Especialmente en Europa, donde es uso común.',
    'efti-compatible': 'Compatible con el Reglamento eFTI',
    'efti-compatible-desc': 'Preparado para el marco europeo de documentación digital.',
    'legal-guarantee': 'Siempre que se garantice autenticidad, integridad y accesibilidad del documento, el eCMR puede sustituir completamente al CMR en papel.',
    'benefits-title': 'Beneficios del eCMR',
    'benefit1-title': '1. Operativa más eficiente',
    'benefit1-1': 'Emisión instantánea',
    'benefit1-2': 'Envío y firma sin papel',
    'benefit1-3': 'Actualizaciones en tiempo real',
    'benefit2-title': '2. Reducción de costes',
    'benefit2-1': 'Menos impresos',
    'benefit2-2': 'Menos incidencias',
    'benefit2-3': 'Menos tiempo de gestión',
    'benefit3-title': '3. Trazabilidad en tiempo real',
    'benefit3-1': 'Cambio de matrícula',
    'benefit3-2': 'Incidencias registradas por el conductor',
    'benefit3-3': 'Flujo totalmente auditable',
    'benefit4-title': '4. Seguridad jurídica',
    'benefit4-1': 'Firma electrónica avanzada eIDAS',
    'benefit4-2': 'Sellado de tiempo',
    'benefit4-3': 'Integridad documental garantizada',
    'bluecmr-features-title': 'eCMR con BlueCMR: funcionalidades clave',
    'creator-title': 'Para el creador del documento',
    'creator-1': 'Plantillas para creación rápida',
    'creator-2': 'Creación vía API REST',
    'creator-3': 'Envío y firma de múltiples documentos a la vez',
    'creator-4': 'Adjuntar fotografías de documentos físicos',
    'driver-title': 'Para el conductor',
    'driver-1': 'Interfaz fácil y rápida',
    'driver-2': 'Registro de incidencias durante el viaje',
    'driver-3': 'Cambios de matrícula, conductor y transferencias de mercancía',
    'driver-4': 'Uso sin conexión',
    'inspection-title': 'Para inspecciones',
    'inspection-1': 'PDF nativo digital conforme a normativa',
    'inspection-2': 'Acceso mediante código QR',
    'inspection-3': 'Preparado para inspecciones según Reglamento eFTI',
    'inspection-4': 'Presentación inmediata a cualquier autoridad',
    'consignee-title': 'Para el destinatario',
    'consignee-1': 'Firma sin app ni instalación',
    'consignee-2': 'Enlace seguro por email o SMS',
    'consignee-3': 'Firma biométrica u OTP',
    'consignee-4': 'Copia automática tras la firma',
    'cta-title': 'Transporte internacional sin papel y con validez legal',
    'cta-subtitle': 'Genere y gestione eCMRs completos, firmados y auditables con BlueCMR.',
    'cta-button': 'Solicitar demo gratuita',
    'cta-trial': 'Probar BlueCMR',
    'notification-wait': 'Por favor, espera unos segundos antes de enviar otro mensaje.',
    'notification-review': 'Por favor, tómate un momento para revisar el formulario.',
    'notification-attempts': 'Demasiados intentos. Por favor, recarga la página.',
    'notification-success': '¡Gracias! Hemos recibido tu solicitud correctamente.',
    'notification-error': 'Error al enviar el formulario. Por favor, inténtalo de nuevo.'
  },
  en: {
    'seo-title': 'eCMR: Digital Waybill for International Transport | BlueCMR',
    'seo-description': 'eCMR digital waybill for international road transport. Create, sign and manage electronic consignment notes with full legal validity across nearly 40 countries.',
    'seo-keywords': 'ecmr, digital waybill, electronic consignment note, international transport, cmr digital, ecmr protocol',
    'valid-countries': '✅ VALID IN NEARLY 40 COUNTRIES - eCMR Protocol 2008',
    'hero-title': 'eCMR: what it is, legal validity and how the digital waybill works',
    'protocol': 'eCMR Protocol 2008',
    'signature': 'eIDAS electronic signature',
    'efti-ready': 'Designed for eFTI',
    'demo-title': 'Request information',
    'demo-subtitle': 'Discover how to digitize your eCMRs',
    'full-name': 'Full name *',
    'company': 'Company *',
    'corporate-email': 'Corporate email *',
    'phone': 'Phone *',
    'accept-privacy': 'I accept the',
    'privacy-policy': 'privacy policy',
    'accept-treatment': 'and the processing of my data to receive commercial information about BlueCMR.',
    'sending': 'Sending...',
    'request-demo': 'Request Free Demo',
    'request-trial': 'Trial period',
    'select-interest': 'Select one of the options:',
    'what-is-title': 'What is eCMR?',
    'what-is-intro': 'eCMR is the CMR waybill in digital format. It has the same legal validity as the paper document and allows:',
    'formalize-contract': 'Formalize the transport contract',
    'document-cargo': 'Document cargo, transport and delivery',
    'register-incidents': 'Register incidents or observations',
    'share-info': 'Share information between shipper, carrier and consignee',
    'electronic-benefits': 'Being electronic, eCMR adds advanced electronic signature, timestamps, document integrity and greater traceability compared to paper format.',
    'how-works-title': 'How does eCMR work?',
    'how-works-intro': 'eCMR operation follows the same operational flow as traditional CMR, but in digital format with complete traceability.',
    'flow-title': 'eCMR flow step by step',
    'step1-title': '1. Document creation',
    'step1-desc': 'eCMR is created digitally from templates, forms or through integration with TMS or ERP systems.',
    'step2-title': '2. Sharing with parties',
    'step2-desc': 'The document is shared with shipper, carrier, driver and consignee through secure links (email, QR or SMS).',
    'step3-title': '3. Electronic signature',
    'step3-desc': 'Parties electronically sign the eCMR at origin and destination, with advanced signature according to eIDAS.',
    'step4-title': '4. Event recording during transport',
    'step4-desc': 'During the journey, incidents, observations, operational changes or driver reservations can be recorded.',
    'step5-title': '5. Closure and preservation',
    'step5-desc': 'Once transport is completed, the eCMR is closed and preserved along with all its evidence, accessible for audits and inspections.',
    'legal-validity-title': 'Legal validity of eCMR',
    'legal-validity-intro': 'eCMR has full legal validity and is legally equivalent to paper CMR.',
    'protocol-2008': 'Regulated by eCMR Protocol (2008)',
    'protocol-2008-desc': 'Full legal equivalence between electronic and paper support.',
    'unefact-design': 'Based on UN/CEFACT standards',
    'unefact-design-desc': 'Design compliant with UN international guidelines.',
    '38-countries': 'Used in nearly 40 countries',
    '38-countries-desc': 'Especially in Europe, where it is commonly used.',
    'efti-compatible': 'Compatible with eFTI Regulation',
    'efti-compatible-desc': 'Ready for the European digital documentation framework.',
    'legal-guarantee': 'As long as authenticity, integrity and accessibility of the document are guaranteed, eCMR can completely replace paper CMR.',
    'benefits-title': 'Benefits of eCMR',
    'benefit1-title': '1. More efficient operations',
    'benefit1-1': 'Instant issuance',
    'benefit1-2': 'Paperless sending and signing',
    'benefit1-3': 'Real-time updates',
    'benefit2-title': '2. Cost reduction',
    'benefit2-1': 'Less printing',
    'benefit2-2': 'Fewer incidents',
    'benefit2-3': 'Less management time',
    'benefit3-title': '3. Real-time traceability',
    'benefit3-1': 'License plate change',
    'benefit3-2': 'Incidents recorded by driver',
    'benefit3-3': 'Fully auditable flow',
    'benefit4-title': '4. Legal security',
    'benefit4-1': 'eIDAS advanced electronic signature',
    'benefit4-2': 'Timestamping',
    'benefit4-3': 'Guaranteed document integrity',
    'bluecmr-features-title': 'eCMR with BlueCMR: key features',
    'creator-title': 'For document creator',
    'creator-1': 'Templates for quick creation',
    'creator-2': 'Creation via REST API',
    'creator-3': 'Sending and signing multiple documents at once',
    'creator-4': 'Attach photographs of physical documents',
    'driver-title': 'For driver',
    'driver-1': 'Easy and fast interface',
    'driver-2': 'Incident recording during trip',
    'driver-3': 'License plate, driver and cargo transfer changes',
    'driver-4': 'Offline use',
    'inspection-title': 'For inspections',
    'inspection-1': 'Native digital PDF compliant with regulations',
    'inspection-2': 'Access via QR code',
    'inspection-3': 'Ready for inspections according to eFTI Regulation',
    'inspection-4': 'Immediate presentation to any authority',
    'consignee-title': 'For consignee',
    'consignee-1': 'Signature without app or installation',
    'consignee-2': 'Secure link by email or SMS',
    'consignee-3': 'Biometric signature or OTP',
    'consignee-4': 'Automatic copy after signature',
    'cta-title': 'International transport without paper and with legal validity',
    'cta-subtitle': 'Generate and manage complete, signed and auditable eCMRs with BlueCMR.',
    'cta-button': 'Request free demo',
    'cta-trial': 'Try BlueCMR',
    'notification-wait': 'Please wait a few seconds before sending another message.',
    'notification-review': 'Please take a moment to review the form.',
    'notification-attempts': 'Too many attempts. Please reload the page.',
    'notification-success': 'Thank you! We have received your request successfully.',
    'notification-error': 'Error sending the form. Please try again.'
  }
};
